import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Printer } from "lucide-react";
import { printPayslip } from "./constants";

export const ViewPayslipDialog = ({
  open,
  onOpenChange,
  payslip,
}) => {
  if (!payslip) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Payslip Details</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded">
            <div>
              <p className="text-sm text-gray-500">Employee</p>
              <p className="font-medium">{payslip.employee_name}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Employee Number</p>
              <p className="font-medium">{payslip.employee_number}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Position</p>
              <p className="font-medium">{payslip.position}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Pay Period</p>
              <p className="font-medium">{payslip.pay_period_start} to {payslip.pay_period_end}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <Card>
              <CardHeader className="py-3">
                <CardTitle className="text-sm text-green-700">Earnings</CardTitle>
              </CardHeader>
              <CardContent className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span>Basic Pay:</span>
                  <span>R {payslip.basic_pay.toFixed(2)}</span>
                </div>
                {payslip.overtime_pay > 0 && (
                  <div className="flex justify-between">
                    <span>Overtime ({payslip.overtime_hours} hrs):</span>
                    <span>R {payslip.overtime_pay.toFixed(2)}</span>
                  </div>
                )}
                {payslip.bonus > 0 && (
                  <div className="flex justify-between">
                    <span>Bonus:</span>
                    <span>R {payslip.bonus.toFixed(2)}</span>
                  </div>
                )}
                {payslip.commission > 0 && (
                  <div className="flex justify-between">
                    <span>Commission:</span>
                    <span>R {payslip.commission.toFixed(2)}</span>
                  </div>
                )}
                <div className="flex justify-between font-bold border-t pt-2">
                  <span>Gross Earnings:</span>
                  <span>R {payslip.gross_earnings.toFixed(2)}</span>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="py-3">
                <CardTitle className="text-sm text-red-700">Deductions</CardTitle>
              </CardHeader>
              <CardContent className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span>PAYE Tax:</span>
                  <span>R {payslip.paye_deduction.toFixed(2)}</span>
                </div>
                <div className="flex justify-between">
                  <span>UIF (1%):</span>
                  <span>R {payslip.uif_deduction.toFixed(2)}</span>
                </div>
                {payslip.loan_deduction > 0 && (
                  <div className="flex justify-between">
                    <span>Loan Repayment:</span>
                    <span>R {payslip.loan_deduction.toFixed(2)}</span>
                  </div>
                )}
                {payslip.other_deductions > 0 && (
                  <div className="flex justify-between">
                    <span>Other:</span>
                    <span>R {payslip.other_deductions.toFixed(2)}</span>
                  </div>
                )}
                <div className="flex justify-between font-bold border-t pt-2">
                  <span>Total Deductions:</span>
                  <span>R {payslip.total_deductions.toFixed(2)}</span>
                </div>
              </CardContent>
            </Card>
          </div>

          <Card className="bg-green-50 border-green-200">
            <CardContent className="p-4 text-center">
              <p className="text-sm text-gray-600">Net Pay</p>
              <p className="text-3xl font-bold text-green-700">R {payslip.net_pay.toFixed(2)}</p>
            </CardContent>
          </Card>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
          <Button onClick={() => printPayslip(payslip)} data-testid="print-payslip-detail-btn">
            <Printer className="h-4 w-4 mr-2" />
            Print
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
